import { isMobileOrTablet } from "common/utils/browser";
import DesignUploadCtaPlpClass from "./design-upload-cta-plp-class";
import DesignUploadCtaPlpPreviewClass from "./design-upload-cta-plp-preview-class";
import DesignUploadCtaPlpFileUploadChannel from "./design-upload-cta-plp-file-upload-channel";
import DesignUploadCtaPlpCookieClass from "./design-upload-cta-plp-cookie-class";
import "./design-upload-cta-plp-modal/design-upload-cta-plp-modal.scss";

const showPreview = () => {
  const url = DesignUploadCtaPlpCookieClass.previewUrl;
  if (!url) return;
  new DesignUploadCtaPlpPreviewClass({ url }).show();
};

const initCable = async () => {
  const uuid = await DesignUploadCtaPlpFileUploadChannel.channelUuid();
  return new DesignUploadCtaPlpFileUploadChannel(uuid);
};

export default async () => {
  const $container = document.querySelector(".js-design-upload-cta-plp");
  if (!$container) return;

  const dtfChannel = await initCable();

  dtfChannel.addSubscription();

  const abTakeAPhotoExperiment = parseInt($container.dataset.abTakeAPhoto, 10);

  const config = {
    designModalSelector: "#design-upload-plp-modal",
    designModalToggle: ".js-plp-modal-toggle-btn",
    fileUploadSelector: ".js-plp-my-device-btn",
    fileUploadInputSelector: ".js-plp-design-file-input",
    libraryUploadSelector: ".js-plp-my-library-btn",
    canvaUploadSelector: ".js-plp-canva-btn",
    dropzoneSelector: ".js-plp-dropzone-container",
    removeDesignSelector: ".js-plp-remove-design",
    dtfChannel
  };

  if (abTakeAPhotoExperiment === 1 && isMobileOrTablet()) {
    config.plpTakePhotoBtnSelector = `.js-plp-take-photo-btn[data-side="front"]`;
  }

  new DesignUploadCtaPlpClass(config).init();

  showPreview();
};
